import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IPrivacyPolicyResponse } from "../../Orchestrator/Types/Interface/IPrivacyPolicy";

export async function getPrivacyPolicyData(): Promise<IApiResponse<IPrivacyPolicyResponse>> {
  const ENDPOINTS = await getEndpoints();
  const params = new URLSearchParams({
    locale: await getLocaleFromCookie()
  });
  const endpoint = `${ENDPOINTS.getPrivacyPolicy}?${params.toString()}`;
  return await cmsApiRequest<IPrivacyPolicyResponse>(endpoint, "GET");
}
